import React from "react";
import { Box, Card, CardContent, CardActions, Avatar, Typography, Button } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const FlipCard = ({ tool }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        perspective: "1000px",
        width: 340,
        height: 300,
        mx: "auto",
        "&:hover .flip-container": {
          transform: "rotateY(180deg) translateX(10px)", // Added slight right shift
        }
      }}
    >
      <Box
        className="flip-container"
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          transition: "transform 0.6s ease",
          transformStyle: "preserve-3d",
        }}
      >
        {/* Front Side */}
        <Card
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backfaceVisibility: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
            border: `2px solid ${theme.palette.secondary.main}`,
            borderRadius: 8,
            boxShadow: theme.shadows[2],
            transform: "translateX(0)", // Initial position
          }}
        >
          <CardContent sx={{ 
            flexGrow: 1,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}>
            <Avatar
              sx={{
                bgcolor: tool.color,
                width: 56,
                height: 56,
                mb: 2,
              }}
            >
              {tool.icon}
            </Avatar>
            <Typography variant="h6" component="h3" gutterBottom sx={{ width: "100%" }}>
              {tool.title}
            </Typography>
            <Typography color="text.secondary" fontSize="0.9rem" sx={{ width: "100%", px: 2 }}>
              {tool.description}
            </Typography>
          </CardContent>
          <CardActions sx={{ justifyContent: "center", pb: 2, width: "100%" }}>
            <Button
              size="small"
              color="primary"
              href={tool.url}
              endIcon={<ArrowForward />}
            >
              Try Now
            </Button>
          </CardActions>
        </Card>

        {/* Back Side */}
        <Card
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            bgcolor: "primary.main",
            color: "primary.contrastText",
            transform: "rotateY(180deg) translateX(30px)", // Matching right shift
            backfaceVisibility: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            px: 2,
            border: `2px solid ${theme.palette.secondary.main}`,
            borderRadius: 8,
            boxShadow: theme.shadows[2],
          }}
        >
          <Typography fontSize="1.7rem" sx={{ mb: 2, px: 2 }}>
            {tool.description || "This tool helps you improve your workflow efficiently."}
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            href={tool.url}
            endIcon={<ArrowForward />}
            sx={{ mt: 2 }}
          >
            Use Now
          </Button>
        </Card>
      </Box>
    </Box>
  );
};

export default FlipCard;